import { Box, Typography } from "@mui/material";
import { T } from "react-translator-component";

const RankingHeader = () => {
  return (
    <Box
      style={{
        display: "flex",
        width: "100%",
        borderBottomWidth: 3,
        borderBottomStyle: "solid",
        marginTop: 20,
        marginBottom: 20,
      }}
      justifyContent="space-between"
    >
      <Box style={{ width: "100%", height: 50 }} flexDirection={"row"} display="flex">
        <img
          alt=""
          style={{ height: 50 }}
          src={require("../../assets/images/trophy.png")}
        />

        <div style={{ width: "100%" }}>
          <Typography variant="h4" component="div" fontWeight="bold" fontSize="30px" lineHeight={1}>
            &nbsp;RANKING!
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{ fontWeight: "400", fontSize: 18, lineHeight: 1 }}
              variant="subtitle1"
              component="div"
            >
              &nbsp; {T("ranking")}
            </Typography>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default RankingHeader;
